module.exports = __webpack_public_path__ + "images/48529f4168d142c225fac8d8e882d26e.png";